import React from "react";
import "../styles/Home.css";
import food from "../assets/food2.jpg";
import privacyImg from "../assets/privacy.png";
export default function PrivacyPolicy() {
  return (
    <div>
      <section
        className="privacy-wrapper"
        style={{ marginLeft: "32px", marginRight: "32px" }}
      >
        {" "}
        <div className="privacy-container">
          <div className="privacy-text">
            <h2 style={{ fontSize: "2.5rem", color: "#39512f" }}>
              Privacy Policy
            </h2>
          </div>
        </div>
        <div className="privacy-container">
          <div className="privacy-text">
            <p style={{ fontSize: "14px", color: "#3e3a35" }}>
              Alfa SouthIn Cafe operates the website alfasouthcafe.com, and we
              are committed to protecting the privacy of our users. This Privacy
              Policy outlines how we collect, use, disclose, and protect your
              information when you use our services.
            </p>

            <h4 style={{ fontSize: "16px", color: "#3e3a35", fontWeight: 600 }}>
              How We Use Collected Information
            </h4>
            <p style={{ fontSize: "14px", color: "#3e3a35" }}>
              We may use the information we collect for various purposes,
              including improving services, personalizing user experience, and
              understanding trends.
            </p>

            <h4 style={{ fontSize: "16px", color: "#3e3a35", fontWeight: 600 }}>
              Data Protection Measures
            </h4>
            <p style={{ fontSize: "14px", color: "#3e3a35" }}>
              We adopt appropriate data collection, storage, and processing
              practices and security measures to protect against unauthorized
              access, alteration, disclosure, or destruction of your personal
              information.
            </p>

            <h4 style={{ fontSize: "16px", color: "#3e3a35", fontWeight: 600 }}>
              Third-Party Services
            </h4>
            <p style={{ fontSize: "14px", color: "#3e3a35" }}>
              There are third-party services on our website. These services have
              their own privacy policies which may be used in combination.
            </p>

            <h4 style={{ fontSize: "16px", color: "#3e3a35", fontWeight: 600 }}>
              User Rights
            </h4>
            <p style={{ fontSize: "14px", color: "#3e3a35" }}>
              We respect your privacy, and we want to clarify your rights
              regarding personal data.
            </p>

            <h4 style={{ fontSize: "16px", color: "#3e3a35", fontWeight: 600 }}>
              Information Collection
            </h4>
            <p style={{ fontSize: "14px", color: "#3e3a35" }}>
              We do not store personal information unless you choose to share it
              voluntarily. You may browse most of our website without providing
              personal data. However, to access certain features, we may ask you
              to voluntarily share your personal details (e.g., name, email,
              contact, address).
            </p>
            <h4 style={{ fontSize: "16px", color: "#3e3a35", fontWeight: 600 }}>
              Disclaimer
            </h4>
            <p style={{ fontSize: "14px", color: "#3e3a35" }}>
              alfasouthcafe.com accepts no responsibility or liability
              whatsoever with regard to material on this website. The material
              is for general information only and may not be comprehensive,
              complete, accurate, or up-to-date.
            </p>
            <h4 style={{ fontSize: "16px", color: "#3e3a35", fontWeight: 600 }}>
              Contact Us
            </h4>
            <p style={{ fontSize: "14px", color: "#3e3a35" }}>
              If you have any questions about this Privacy Policy, the practices
              of this site, or your dealings with this site, please contact us
              at Call / Whatsapp: 077220 06638 Email: alfasouthin@gmail.com This
              Privacy Policy was last updated on [11/July/2025].
            </p>
          </div>

          <div className="privacy-side">
            <div className="info-box">
              <div className="info1">
                {" "}
                <span className="info-icon">ℹ️</span>
              </div>
              <div>
                <p style={{ fontSize: "19px", color: "#0d1013" }}>
                  Information We Collect
                </p>
                <p style={{ fontSize: "14px", color: "#0d1013" }}>
                  We may collect personal information from users in various
                  ways, including when users visit our site, register on the
                  site, fill out a form, and in connection with other
                  activities, services, features, or resources made available on
                  our site.
                </p>
              </div>
            </div>

            <img
              src={privacyImg}
              alt="Privacy Policy"
              className="privacy-img"
            />

            <div className="privacy-footer">
              <h5
                style={{ fontSize: "16px", color: "#3e3a35", fontWeight: 600 }}
              >
                Changes to This Privacy Policy
              </h5>
              <p style={{ fontSize: "14px", color: "#3e3a35" }}>
                alfasouthcafe.com has the discretion to update this privacy
                policy at any time. We encourage users to check this page
                regularly for any changes to stay informed.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
